import * as React from "react";

const IconTextLinkShareHover: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 12 11"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                fill="currentColor"
                d="M11.805 4.801L7.68 8.343a.563.563 0 01-.93-.426v-2.04c-3.635.052-5.202.954-4.14 4.352.119.378-.337.67-.657.437C.928 9.92 0 8.496 0 7.054c0-3.568 2.986-4.322 6.75-4.367V.813c0-.485.57-.738.93-.426l4.125 3.542c.26.244.26.647 0 .872z"
            />
        </svg>
    );
};

export default React.memo(IconTextLinkShareHover);
